import { NgModule } from '@angular/core';
import { AppTimerComponent } from "./app-timer.component";

@NgModule({
    declarations: [
        AppTimerComponent,
    ],
    exports: [
        AppTimerComponent,
    ]
})
export class AppTimerModule { }